// Polyfill Buffer for @react-pdf/renderer (webpack 5 removed Node.js polyfills)
import { Buffer } from 'buffer';
/* eslint-disable no-undef */
if (typeof window !== 'undefined' && typeof window.Buffer === 'undefined') {
  window.Buffer = Buffer;
}
/* eslint-enable no-undef */
